// extracted by mini-css-extract-plugin
module.exports = {"mainContainerProduct":"styles_mainContainerProduct__1I-4j"};